import { render, staticRenderFns } from "./OrderAttachmentDocuments.vue?vue&type=template&id=b514a69c&scoped=true&"
import script from "./OrderAttachmentDocuments.vue?vue&type=script&lang=js&"
export * from "./OrderAttachmentDocuments.vue?vue&type=script&lang=js&"
import style0 from "./OrderAttachmentDocuments.vue?vue&type=style&index=0&id=b514a69c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b514a69c",
  null
  
)

export default component.exports